export default __webpack_public_path__ + "static/media/top-indexing-states.png";